import React from "react";
import moment from "moment";
import { FormGroup, Input, ControlLabel, HelpBlock } from "components/bootstrap";
import { TimeUnitInput } from "components/common";
import { extractDurationAndUnit } from "components/common/TimeUnitInput";
import ValidationErrors from "./ValidationErrors";
const TIME_UNITS = ["HOURS", "MINUTES", "SECONDS"];
const PercentageThresholdForm = ({ config, handleConfigFieldChange, validation }) => {
  const executeEvery = extractDurationAndUnit(
    moment.duration(config.execute_every_seconds, "seconds").asMilliseconds(),
    TIME_UNITS
  );
  const handleExecuteEveryChange = (nextValue, nextUnit) => {
    const seconds = moment.duration(nextValue, nextUnit.toLowerCase()).asSeconds();
    handleConfigFieldChange("execute_every_seconds", seconds.toString());
  };
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(FormGroup, { validationState: validation.errors.threshold ? "error" : null }, /* @__PURE__ */ React.createElement(
    Input,
    {
      id: "threshold",
      name: "threshold",
      label: "Percentage Threshold (%)",
      type: "number",
      min: 0,
      max: 100,
      help: "Percentage of your billing period's allowed volume (0-100)",
      value: config.threshold,
      onChange: (e) => handleConfigFieldChange("threshold", e.target.value),
      required: true
    }
  ), /* @__PURE__ */ React.createElement(ValidationErrors, { errors: validation.errors.threshold })), /* @__PURE__ */ React.createElement(FormGroup, null, /* @__PURE__ */ React.createElement(ControlLabel, null, "Time Range Mode"), /* @__PURE__ */ React.createElement(HelpBlock, null, /* @__PURE__ */ React.createElement("strong", null, "Billing Period Based"), " - Percentage threshold monitoring is based on your license billing period (daily for daily usage, total contract duration for drawdown). License usage accumulates from the start of the current billing period and compares against your allowed volume for that period.")), /* @__PURE__ */ React.createElement(FormGroup, { validationState: validation.errors.execute_every_seconds ? "error" : null }, /* @__PURE__ */ React.createElement(
    TimeUnitInput,
    {
      label: "Execute Every",
      update: handleExecuteEveryChange,
      value: executeEvery.duration,
      unit: executeEvery.unit,
      units: TIME_UNITS,
      required: true
    }
  ), /* @__PURE__ */ React.createElement(ValidationErrors, { errors: validation.errors.execute_every_seconds })));
};
export default PercentageThresholdForm;
